import React from 'react'

const Common = ({title}) => {
    return (
        <h1>{title}</h1>
    )
}

export default Common